<template>
  <main class="push-campaign-creator">
    <div class="editor-container">
      <CampaignCreatorHeader
        :current-merchant="currentMerchant"
        :stashboard-headers="stashboardHeaders"
      />

      <stashboard-media-uploader />

      <editor
        :value="pushContentEditor"
        @update:value="updatePushContentEditor"
        ref="editor"
        class='border-can-error'
        v-touch:push_content
        v-has-error:push_content
      />

      <campaign-action-bar
        class="border-can-error"
        :campaign="campaign"
        @shouldInsertText="shouldInsertText"
        v-has-error:push_content
      />
    </div>
  </main>
</template>

<script>
import Editor from "./editor";
import CampaignActionBar from "./action-bar/campaign-action-bar";
import CampaignCreatorHeader from "./campaign-creator-header";
import StashboardMediaUploader from "./stashboard-media-uploader/stashboard-media-uploader.vue";
import {mapGetters} from "vuex";
import {AddImageModal, Touch, HasError} from "@springbig/sb-components";
import {stashboardAPI} from "../../services/api/stashboardAPI";

export default {
  name: "push-campaign-creator",
  directives: {Touch, HasError},
  components: {
    CampaignActionBar,
    Editor,
    AddImageModal,
    StashboardMediaUploader,
    CampaignCreatorHeader
  },

  props: {
    campaign: Object,
    ad: Object,
    pushContentEditor: String
  },
  data() {
    return {
      stashboardHeaders: [],
    }
  },
  async created() {
    this.stashboardHeaders = await stashboardAPI.getStashboardHeaders();
  },
  methods: {
    shouldInsertText(text) {
      this.$refs.editor.insertText(text);
    },
    async updatePushContentEditor(text) {
      this.$emit("update:push-content-editor", text);
    },
    
    updateOrder(item) {
      this.$emit('update:campaign', {push_stashboard_media_order: item.order || []})
    },
    shouldInsertText(text) {
      this.$refs.editor.insertText(text);
    }
  },

  computed: {
    invalidText() { return this.$store.getters.hasError('push_content'); },
    ...mapGetters(['classicCampaignsEnabled', 'currentMerchant']),
  }
}
</script>

<style scoped>
.push-campaign-creator {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.editor-container {
  display:flex;
  flex-direction: column;
  width: 100%;
}

.invalid-text {
  border-color: #f91253;
}

.sb-loading-icon >>> svg {
  fill: #128ff9;
}

header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  background-color: #A6D4FC;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
}

header .logo {
  height: 20px;
  width: auto;
}

.rounded-blue {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.remove-btn {
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  background: white;
  padding: 4px 8px;
  border-radius: 4px;
  color: #A6D4FC;
  border-color: #A6D4FC;
}

img {
  height: 100%;
}
</style>
